import axios from "../axiosClient";

export const getTests = async (
  PageNumber: any,
  pageSize: any,
  tcCode: any,
  siteCode: any,
  blockCode: any,
  testTypeId: any,
  testScheduleTypeId: any,
  SortBy: any,
  SortDirection: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/TestConfiguration/getTestConfigurationsByLocation`,
    {
      params: {
        PageNumber,
        pageSize,
        tcCode,
        siteCode,
        blockCode,
        testTypeId,
        testScheduleTypeId,
        SortBy,
        SortDirection,
      },
      signal,
    }
  );

  return res?.data;
};
